// Upload do mockup/foto do projeto para o Storage do Supabase (bucket 'mockups',
// público para leitura). Uma foto por projeto (agrupa os sabores).
import { supabase } from './supabase';

const BUCKET = 'mockups';

export async function uploadMockup(
  orgId: string,
  productId: string,
  file: File,
): Promise<{ error?: string; url?: string }> {
  if (!file.type.startsWith('image/')) return { error: 'Envie um arquivo de imagem.' };
  if (file.size > 5 * 1024 * 1024) return { error: 'Imagem muito grande (máx. 5 MB).' };
  const ext = (file.name.split('.').pop() || 'png').toLowerCase().replace(/[^a-z0-9]/g, '');
  const path = `${orgId}/${productId}.${ext}`;
  const { error } = await supabase.storage
    .from(BUCKET)
    .upload(path, file, { upsert: true, contentType: file.type, cacheControl: '3600' });
  if (error) return { error: error.message };
  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
  return { url: `${data.publicUrl}?v=${Date.now()}` };
}

/** Foto do produto em acompanhamento de saída de linha (mesmo bucket público). */
export async function uploadDiscImage(
  orgId: string,
  discId: string,
  file: File,
): Promise<{ error?: string; url?: string }> {
  if (!file.type.startsWith('image/')) return { error: 'Envie um arquivo de imagem.' };
  if (file.size > 5 * 1024 * 1024) return { error: 'Imagem muito grande (máx. 5 MB).' };
  const ext = (file.name.split('.').pop() || 'png').toLowerCase().replace(/[^a-z0-9]/g, '');
  const path = `${orgId}/disc-${discId}.${ext}`;
  const { error } = await supabase.storage
    .from(BUCKET)
    .upload(path, file, { upsert: true, contentType: file.type, cacheControl: '3600' });
  if (error) return { error: error.message };
  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
  return { url: `${data.publicUrl}?v=${Date.now()}` };
}

/** Foto do produto na Rampa de lançamentos (mesmo bucket público). */
export async function uploadRampImage(
  orgId: string,
  rampId: string,
  file: File,
): Promise<{ error?: string; url?: string }> {
  if (!file.type.startsWith('image/')) return { error: 'Envie um arquivo de imagem.' };
  if (file.size > 5 * 1024 * 1024) return { error: 'Imagem muito grande (máx. 5 MB).' };
  const ext = (file.name.split('.').pop() || 'png').toLowerCase().replace(/[^a-z0-9]/g, '');
  const path = `${orgId}/ramp-${rampId}.${ext}`;
  const { error } = await supabase.storage
    .from(BUCKET)
    .upload(path, file, { upsert: true, contentType: file.type, cacheControl: '3600' });
  if (error) return { error: error.message };
  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
  return { url: `${data.publicUrl}?v=${Date.now()}` };
}

const EVID = 'evidencias';

/** Sobe um anexo (evidência) de comentário. Devolve URL pública + nome do arquivo. */
export async function uploadEvidencia(
  orgId: string,
  productId: string,
  n: number,
  file: File,
): Promise<{ error?: string; url?: string; name?: string }> {
  if (file.size > 15 * 1024 * 1024) return { error: 'Arquivo muito grande (máx. 15 MB).' };
  const ext = (file.name.split('.').pop() || 'bin').toLowerCase().replace(/[^a-z0-9]/g, '');
  const path = `${orgId}/${productId}/${n}-${Date.now()}.${ext}`;
  const { error } = await supabase.storage
    .from(EVID)
    .upload(path, file, { upsert: false, contentType: file.type || 'application/octet-stream' });
  if (error) return { error: error.message };
  const { data } = supabase.storage.from(EVID).getPublicUrl(path);
  return { url: data.publicUrl, name: file.name };
}
